'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = withTranslators;

var _recompose = require('recompose');

var _contextTypes = require('./contextTypes.js');

var contextTypes = _interopRequireWildcard(_contextTypes);

var _forceUpdatedComponent = require('./forceUpdatedComponent.js');

var _forceUpdatedComponent2 = _interopRequireDefault(_forceUpdatedComponent);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}
/**
 * Provides the given component with translator functions
 * as props.
 */


function withTranslators(WrappedComponent) {
  var forceUpdatedWrappedComponent = (0, _forceUpdatedComponent2.default)(WrappedComponent);
  var withTranslators = (0, _recompose.getContext)(contextTypes)(forceUpdatedWrappedComponent);
  withTranslators.displayName = (0, _recompose.wrapDisplayName)(WrappedComponent, 'withTranslators');
  return withTranslators;
}